const NAME = "TAX_TABLE";

export default NAME;
